export const AI_NOTEBOOK_FEATURE_KEY = 'notebook-template-ai';

export const AI_NOTEBOOK_ALLOWED_MIME_TYPES_LIST = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
] as const;

export const AI_NOTEBOOK_ALLOWED_MIME_TYPES: ReadonlySet<string> = new Set(
  AI_NOTEBOOK_ALLOWED_MIME_TYPES_LIST
);

export const AI_NOTEBOOK_MAX_FILE_SIZE_MB = 25;
export const AI_NOTEBOOK_MAX_FILE_SIZE_BYTES =
  AI_NOTEBOOK_MAX_FILE_SIZE_MB * 1024 * 1024;
export const AI_NOTEBOOK_MAX_UPLOAD_FILES = 3;

export const AI_NOTEBOOK_MAX_PROMPT_LENGTH = 400;
export const AI_NOTEBOOK_MAX_TOTAL_LESSON_PLAN_CHARS = 45000;
export const AI_NOTEBOOK_MAX_TEMPLATE_SUMMARIES_TO_MODEL = 20;
export const AI_NOTEBOOK_MAX_TEMPLATE_SUMMARIES_CHARS = 12000;
export const AI_NOTEBOOK_ARTIFACT_RETENTION_DAYS = 7;
export const AI_NOTEBOOK_PROMPT_ARTIFACT_RETENTION_HOURS = 24;

export const AI_NOTEBOOK_INSUFFICIENT_DETAIL_MESSAGE =
  'We could not find enough instructional detail to build a notebook. Please upload a clearer lesson plan or add more detail.';

export const AI_NOTEBOOK_NO_MATCH_MESSAGE =
  'We could not find a strong match to your lesson plan. Please upload a clearer lesson plan or add more detail.';

export const AI_NOTEBOOK_MATCH_MIN_CONFIDENCE = 0.35;
export const AI_NOTEBOOK_SIMILARITY_GUARD_RATIO = 0.8;
export const AI_NOTEBOOK_SIMILARITY_CONFIDENCE_MIN = 0.6;

export const AI_NOTEBOOK_DEBUG_ENABLED =
  process.env.AI_NOTEBOOK_DEBUG === 'true';

const parsePositiveInt = (value: string | undefined, fallback: number) => {
  const parsed = Number.parseInt(value ?? '', 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const AI_NOTEBOOK_SAFETY_GUARDRAILS_ENABLED =
  process.env.AI_NOTEBOOK_SAFETY_GUARDRAILS !== 'false';
export const AI_NOTEBOOK_SAFETY_PROVIDER_TIMEOUT_MS = parsePositiveInt(
  process.env.AI_NOTEBOOK_SAFETY_PROVIDER_TIMEOUT_MS,
  3000
);

const VERCEL_NON_PRODUCTION_ENVS = new Set(['DEV', 'PREVIEW', 'STAGING']);

export const shouldPersistAiNotebookPrompts = () => {
  if (process.env.AI_NOTEBOOK_PERSIST_PROMPTS !== 'true') {
    return false;
  }

  const vercelEnv = process.env.VERCEL_ENV?.toUpperCase();
  if (vercelEnv && VERCEL_NON_PRODUCTION_ENVS.has(vercelEnv)) {
    return true;
  }

  return process.env.NODE_ENV !== 'production';
};
